<svelte:head>

    <title>Payment • keyosh</title>

</svelte:head>

<script>
    import Payment from "../../components/onboarding/payment.svelte"
</script>


<section>

    <Payment />

</section>


<style>

    section {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: inherit;
        position: relative;
    }

    @media screen and (max-width: 1024px) {

        section {
            flex-direction: column;
        }

    }

</style>
